module.exports = __webpack_public_path__ + "img/icon_brand.108d7c69.svg";